import { AppTableControls } from 'common/TableControls/TableControls';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import type { Building } from 'services/api';

export const getBuidingsTableColumns = (
  edit: (id: number) => void,
  remove: (id: number) => void,
): AppTableColumn<Building>[] => {
  const columns: AppTableColumn<Building>[] = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: ['id'],
      maxWidth: '10rem',
    },
    {
      key: 'name',
      title: 'Наименование здания',
      dataIndex: ['name'],
    },
    {
      key: 'address',
      title: 'Адрес',
      dataIndex: ['address'],
    },
    {
      key: 'roomCount',
      title: 'Количество аудиторий',
      dataIndex: ['roomCount'],
    },
    {
      key: 'controls',
      title: '',
      dataIndex: [],
      maxWidth: '10rem',
      render: (value: any, record: Building) => {
        const editBuilding = () => edit(record.id);
        const removeBuilding = () => remove(record.id);

        return <AppTableControls edit={editBuilding} remove={removeBuilding} />;
      },
    },
  ];

  return columns;
};
